import { Icon } from "components/icon/Icon";
import { useAuth } from "hooks/Auth/useAuth";
import { useState } from "react";
import useChatbotStore from "stores/chatbot/useChatbotStore";
import { StyledChatbotButton } from "./style";

export const ChatbotButton = () => {
  const { isLoggedIn } = useAuth();
  const { isChatbotOpen, setIsChatbotOpen } = useChatbotStore();
  const [isHovered, setIsHovered] = useState(false);

  if (!isLoggedIn) return null;
  return (
    <StyledChatbotButton
      className={`${isChatbotOpen ? "active" : ""}`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={() => setIsChatbotOpen(!isChatbotOpen)}
    >
      <Icon
        strokeWidth={0.5}
        icon="AI02"
        size={24}
        stroke="--text-gray-normal"
        fill={isHovered || isChatbotOpen ? "--text-gray-normal" : undefined}
      />
    </StyledChatbotButton>
  );
};
